(ns pfo.collection.spec)

(def collection
  [:map
   [:id :int]
   [:name :string]])

(def collection-with-type
  (conj
    collection
    [:collection_type
     [:map
      [:id :int]
      [:ref :string]]]))
